







































/* General */

/* Mixins */
import SearchableDropdownMixin from '@/mixins/searchable-dropdown.mixin'

/* Helpers */
import AssigneeAssistant from '@/helpers/assignee-assistant'

/* Types */
import { IPersonBase } from '@/api/types/response.types'

export default SearchableDropdownMixin.extend({
  name: 'AssignmentPicker',

  props: {
    options: {
      type: Array as () => IPersonBase[],
      default: (): IPersonBase[] => [],
    },
    hideName: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'small',
    },
    /* Used for Jobs, but abstracting name to make this more abstract-y */
    title: {
      type: String,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      avatarSize: 19,
    }
  },

  computed: {
    totalOptionsCount(): number {
      return this.options.length
    },
    filteredOptions(): IPersonBase[] {
      const result = AssigneeAssistant.getFullAssigneeOptions(
        this.options,
        this.$permissions,
      )

      if (this.filterQuery.length === 0) {
        return result
      }

      return result.filter(person => {
        return person.name
          .toLowerCase()
          .includes(this.filterQuery.toLowerCase())
      })
    },
    /* Null, if unassigned */
    selectedPerson(): IPersonBase {
      return this.options.find(p => p.id === this.internalSelectedID)
    },
    loggedInPerson(): IPersonBase {
      return this.options.find(p => this.$permissions.isLoggedInUser(p.id))
    },
    dropdownTitle(): string {
      return this.title ? this.title : 'People'
    },
    modifiers(): Array<String> {
      const selectors = [this.size]

      if (this.isDisabled) {
        selectors.push('disabled')
      }
      return selectors
    },
  },

  methods: {
    getName(person: IPersonBase) {
      return person ? person.name : 'Unassigned'
    },
  },
})
